import { render, staticRenderFns } from "./DepositSetting.vue?vue&type=template&id=cfa86750&"
import script from "./DepositSetting.vue?vue&type=script&lang=js&"
export * from "./DepositSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports